export default __webpack_public_path__ + "static/image8-eda5606603135985ee40d853816c0e46.png";